$.view.addHelper({
	/**
	 * Encode string for URI usage
	 *
	 * @returns {String}
	 */
	encode() {
		return encodeURIComponent(this.val);
	},

	/**
	 * Replace newlines with paragraphs
	 *
	 * @returns {String}
	 */
	nl2br() {
		return this.val ?
			'<p>' + this.val.replace(/\n+/g, '</p><p>') + '</p>' :
			'';
	},

	/**
	 * Render paragraphs and lists
	 *
	 * @returns {String}
	 */
	markdown() {
		return LS.util.markdown(this.val);
	},

	/**
	 * Conditionally output as plural
	 *
	 * @param {String} label
	 * @returns {String}
	 */
	plural(label) {
		return LS.util.plural(label, this.val);
	},

	/**
	 * Capitalize first letter
	 *
	 * @returns {String}
	 */
	capitalize() {
		return LS.util.capitalize(this.val);
	}
});